export default "__VITE_ASSET__BdS0RQsq__"